(function(){
  function addBusinessDays(date, days) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0) added++;
    }
    return d;
  }
  function formatDate(date) {
    return date.toLocaleDateString('en-IN', { day:'numeric', month:'short' });
  }
  function init() {
    document.querySelectorAll('.hb-delivery-checker').forEach(function(box){
      if (box.dataset.deliveryInit === '1') return;
      box.dataset.deliveryInit = '1';
      var input = box.querySelector('.hb-delivery-checker__input');
      var button = box.querySelector('.hb-delivery-checker__button');
      var message = box.querySelector('.hb-delivery-checker__message');
      if (!input || !button || !message) return;
      function check() {
        var pin = input.value.replace(/\\D/g,'');
        if (!/^[1-9][0-9]{5}$/.test(pin)) {
          message.textContent = 'Please enter a valid 6-digit PIN code.';
          message.className = 'hb-delivery-checker__message is-error';
          return;
        }
        var today = new Date();
        var prep = addBusinessDays(today, 1);
        var minDate = addBusinessDays(prep, 3);
        var maxDate = addBusinessDays(prep, 5);
        message.innerHTML = '<strong>✓ PIN code verified</strong><br><span>Estimated delivery: <strong>' + formatDate(minDate) + ' – ' + formatDate(maxDate) + '</strong></span><small>Includes 1 day for preparation + 3–5 days for delivery.</small>';
        message.className = 'hb-delivery-checker__message is-success';
      }
      button.addEventListener('click', check);
      input.addEventListener('keydown', function(e){ if(e.key === 'Enter') check(); });
      input.addEventListener('input', function(){ input.value = input.value.replace(/\\D/g,'').slice(0,6); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();